module.exports = __webpack_public_path__ + "static/9-22345396553dbdf480c7055b0846bc29.jpg";